import { useMemo } from "react";
import { object, bool, string, number, array } from "yup";
import { AdminService, AdminServiceForm } from "src/domain/AdminService";

export type AcceptCGU = {
  acceptCGU: boolean;
};


const useValidationSchemaService = (ranksUsed: number[]) => {

  const requiredMessage = "form.error.notEmpty";

  return useMemo(() => {

    // Schema représentant l'ensemble des champs du formulaire
    // inclu la validation de ces champs si nécessaire

    const validationSchema = object<AdminServiceForm>().shape({
      id: string().nullable(),
      code: string().required(requiredMessage),
      url: string().nullable(),
      urlAffilie: string().nullable(),
      urlInterne: string().nullable(),
      urlSubscription: string().nullable(),
      labelFr: string().required(requiredMessage),
      labelDe: string().nullable(),
      labelEn: string().nullable(),
      descriptionFr: string().required(requiredMessage),
      descriptionDe: string().nullable(),
      descriptionEn: string().nullable(),
      flagNew: bool().nullable(),
      displayedIfAbsent: bool().nullable(),
      openInNewTab: bool().nullable(),
      rank: number().required(requiredMessage).test("is-rank-unique", requiredMessage, function(value) {
        if (value === 0) {
          return false;
        }
        return true;
      })
        .test("is-rank-unique", "Rank déja utilisé", function(value) {
          const { rankInit } = this.parent;

          if (value && value !== rankInit && ranksUsed.includes(value)) {
            return false;
          }
          return true;
        }),
    });
    return validationSchema;
  }, [ranksUsed]);
};

export default useValidationSchemaService;
